/*
  innvolo-encabezado.js
  Comportamiento de la cabecera propia: megamenú, buscador, panel móvil y velo.

  Regla de oro: solo hay una capa abierta a la vez. Abrir el megamenú cierra el
  buscador y al revés; el velo y la tecla Escape cierran lo que haya.

  Todo es progresivo: sin JS los enlaces siguen funcionando y el formulario de
  búsqueda hace su envío normal a /search.
*/

(function () {
  'use strict';

  var cabecera = document.querySelector('[data-innvolo-cabecera]');
  if (!cabecera) return;

  var velo = document.querySelector('[data-innvolo-velo]');
  var panel = document.querySelector('[data-innvolo-panel]');
  var mega = cabecera.querySelector('[data-innvolo-mega]');
  var busca = cabecera.querySelector('[data-innvolo-busca]');
  var bMega = cabecera.querySelector('[data-innvolo-mega-boton]');
  var bBusca = cabecera.querySelector('[data-innvolo-busca-boton]');
  var bPanel = cabecera.querySelector('[data-innvolo-panel-boton]');
  var bCierra = panel && panel.querySelector('[data-innvolo-panel-cerrar]');

  function abierto(el) {
    return el && el.dataset.innvoloAbre === 'si';
  }

  function pintaVelo() {
    if (!velo) return;
    var algo = abierto(mega) || abierto(busca) || abierto(panel);
    velo.dataset.innvoloAbre = algo ? 'si' : 'no';
  }

  function cierraMega() {
    if (!mega) return;
    mega.dataset.innvoloAbre = 'no';
    cabecera.dataset.innvoloMegaAbierto = 'no';
    if (bMega) bMega.setAttribute('aria-expanded', 'false');
    pintaVelo();
  }

  function cierraBusca() {
    if (!busca) return;
    busca.dataset.innvoloAbre = 'no';
    if (bBusca) bBusca.setAttribute('aria-expanded', 'false');
    if (!abierto(mega)) cabecera.dataset.innvoloMegaAbierto = 'no';
    pintaVelo();
  }

  function abreMega() {
    if (!mega) return;
    cierraBusca();
    mega.dataset.innvoloAbre = 'si';
    cabecera.dataset.innvoloMegaAbierto = 'si';
    if (bMega) bMega.setAttribute('aria-expanded', 'true');
    pintaVelo();
  }

  function abreBusca() {
    if (!busca) return;
    cierraMega();
    busca.dataset.innvoloAbre = 'si';
    cabecera.dataset.innvoloMegaAbierto = 'si';
    if (bBusca) bBusca.setAttribute('aria-expanded', 'true');
    pintaVelo();
    var campo = busca.querySelector('[data-innvolo-busca-campo]');
    if (campo) campo.focus();
  }

  function cierraPanel() {
    if (!panel) return;
    panel.dataset.innvoloAbre = 'no';
    if (bPanel) bPanel.setAttribute('aria-expanded', 'false');
    document.body.dataset.innvoloBloqueado = 'no';
    pintaVelo();
    if (bPanel) bPanel.focus();
  }

  function abrePanel() {
    if (!panel) return;
    panel.dataset.innvoloAbre = 'si';
    if (bPanel) bPanel.setAttribute('aria-expanded', 'true');
    document.body.dataset.innvoloBloqueado = 'si';
    pintaVelo();
    if (bCierra) bCierra.focus();
  }

  function cierraTodo() {
    if (abierto(panel)) {
      cierraPanel();
      return;
    }
    cierraMega();
    cierraBusca();
  }

  if (bMega) {
    bMega.addEventListener('click', function () {
      if (abierto(mega)) {
        cierraMega();
      } else {
        abreMega();
      }
    });
  }

  if (bBusca) {
    bBusca.addEventListener('click', function () {
      if (abierto(busca)) {
        cierraBusca();
      } else {
        abreBusca();
      }
    });
  }

  if (bPanel) bPanel.addEventListener('click', abrePanel);
  if (bCierra) bCierra.addEventListener('click', cierraPanel);
  if (velo) velo.addEventListener('click', cierraTodo);

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') cierraTodo();
  });

  /* Al elegir algo dentro de una capa, esa capa se cierra sola. */
  if (mega) {
    mega.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', cierraMega);
    });
  }
  if (busca) {
    busca.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', cierraBusca);
    });
  }
  if (panel) {
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', cierraPanel);
    });
  }

  /* El megamenú no debe quedarse abierto si el puntero abandona la cabecera. */
  cabecera.addEventListener('mouseleave', function () {
    if (abierto(mega)) cierraMega();
  });

  /*
    Al sustituir la cabecera de Horizon (D-025) dejó de ejecutarse el script de
    layout/theme.liquid que publica --header-height y --header-group-height:
    aquel busca <header-component> y sale si no lo encuentra.

    Esas dos variables las consume el resto del tema para desplazar anclas y
    posicionar barras pegajosas, así que las calculamos aquí. Es el precio de
    hacer cabecera propia sin romper lo que ya funcionaba.
  */
  function mideCabecera() {
    var grupo = document.getElementById('header-group');
    var alto = cabecera.offsetHeight;
    var altoGrupo = 0;

    if (grupo) {
      for (var i = 0; i < grupo.children.length; i++) {
        var hijo = grupo.children[i];
        if (hijo instanceof HTMLElement && !hijo.contains(cabecera)) {
          altoGrupo += hijo.offsetHeight;
        }
      }
    }

    document.body.style.setProperty('--header-height', alto + 'px');
    document.body.style.setProperty('--header-group-height', altoGrupo + 'px');
  }

  mideCabecera();

  if ('ResizeObserver' in window) {
    new ResizeObserver(mideCabecera).observe(cabecera);
  } else {
    window.addEventListener('resize', mideCabecera);
  }

  /* ------------------------------------------------------------------
     Cabecera transparente sobre el hero — solo en celular (2026-07-27)

     Se enciende SOLO si la página tiene hero. En una colección o una ficha,
     una cabecera transparente sobre fondo blanco desaparecería: no habría nada
     debajo que le diera contraste.

     El estado vive en `<html>` y no en la cabecera porque lo necesitan las dos
     piezas: la cabecera para volverse invisible y el hero para subir por
     debajo de ella. Cada una lo lee desde su propio CSS.

     Sin JavaScript no pasa nada: el atributo no se pone y la cabecera se queda
     sólida, que es el estado por defecto.
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     La cabecera es parte del hero — solo en celular (2026-07-27)

     Se enciende SOLO si la página tiene hero. En una colección o una ficha,
     una cabecera transparente sobre fondo blanco desaparecería.

     Ya no hay estado de scroll: el usuario la quiso transparente siempre, y
     para que eso no acabe en logo blanco sobre fondo blanco, en celular la
     cabecera deja de ser pegajosa y se va con la página. El CSS lo hace.

     El estado vive en `<html>` y no en la cabecera porque lo necesitan las dos
     piezas: la cabecera para volverse invisible y el hero para subir por
     debajo de ella.

     Sin JavaScript no pasa nada: el atributo no se pone y la cabecera se queda
     sólida y pegajosa, que es el estado por defecto.
     ------------------------------------------------------------------ */
  var doc = document.documentElement;
  var hero = document.querySelector('.innvolo-hero');
  var angosto = window.matchMedia('(max-width: 720px)');

  function evaluaHero() {
    doc.dataset.innvoloSobreHero = hero && angosto.matches ? 'si' : 'no';
  }

  if (hero) {
    if (angosto.addEventListener) {
      angosto.addEventListener('change', evaluaHero);
    } else if (angosto.addListener) {
      angosto.addListener(evaluaHero);
    }
    evaluaHero();
  }
})();
